module.exports = __webpack_public_path__ + "img/silver1.012c85ac.png";